import { render, staticRenderFns } from "./ListMixin.vue?vue&type=template&id=51ffe3f2&scoped=true&"
import script from "./ListMixin.vue?vue&type=script&lang=js&"
export * from "./ListMixin.vue?vue&type=script&lang=js&"
import style0 from "./ListMixin.vue?vue&type=style&index=0&id=51ffe3f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffe3f2",
  null
  
)

export default component.exports